import React, { useEffect, useState } from 'react'
import axios from 'axios';
import API_URL from '../../../ApiUrl'
import { useForm } from "react-hook-form"
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const FormAlamat = ({ nextStep, setInfoAlamat, infoAlamat, setKurir, items }) => {
    const [provinsi, setProvinsi] = useState([]);
    const [kabupaten, setKabupaten] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const formSchema = Yup.object().shape({
        nama_lengkap: Yup.string().required("Nama wajib diisi"),
        email:        Yup.string().required("Email wajib diisi").email('Email tidak valid'),
        alamat:       Yup.string().required("Alamat wajib diisi"),
        provinsi:     Yup.string().required("Pilih provinsi"),
        notelp:       Yup.string().required("Nomor Telepon wajib diisi"),
        kabupaten:    Yup.string().required("Pilih Kabupaten/Kota"),
        postal_code:  Yup.string().required("Kode Pos wajib diisi"),
    });

    const { register, handleSubmit, formState: { errors }, setError } = useForm({
        mode: "onTouched",
        resolver: yupResolver(formSchema),
    });

    const onSubmit = (data) => {
        setIsLoading(true);
        axios.get(`https://api.biteship.com/v1/maps/areas?countries=ID&input=${data.postal_code}&type=single`, {
            headers: { 'Authorization': `Bearer ${API_URL.biteship_token}` }
        })
        .then(res => {
            const area = res.data.areas;
            if (area.length < 1) {
                setError('postal_code', { type: 'custom', message: 'Kode Pos tidak terdaftar / tidak valid' });
                setIsLoading(false);
            } else {
                setInfoAlamat(data);
                getKurirOngkir(data);
            }
        })
        .catch(err => { console.log(err); setIsLoading(false); });
    };

    useEffect(() => { getDataPropinsi(); }, []);

    const getKurirOngkir = (data) => {
        const payload = {
            origin_postal_code:      80111,
            destination_postal_code: parseInt(data.postal_code),
            couriers: "jne,jnt,grab,gojek",
            items,
        };
        axios({ method: 'POST', url: 'https://api.biteship.com/v1/rates/couriers', data: payload,
            headers: { Authorization: `Bearer ${API_URL.biteship_token}` }
        })
        .then(res => { setKurir(res.data.pricing); nextStep(); })
        .catch(err => console.log(err))
        .finally(() => setIsLoading(false));
    };

    const loadKabKota = (e) => {
        const { name, value } = e.target;
        setInfoAlamat({ ...infoAlamat, [name]: value });
        axios.get(API_URL.superStudent2 + '/master/kabupaten/' + value)
            .then(res => setKabupaten(res.data.data))
            .catch(err => console.log(err));
    };

    const setKabKota = (e) => {
        const { name, value } = e.target;
        setInfoAlamat({ ...infoAlamat, [name]: value });
    };

    const getDataPropinsi = () => {
        axios.get(API_URL.superStudent2 + '/master/provinces')
            .then(res => setProvinsi(res.data.data))
            .catch(err => console.log(err));
    };

    return (
        <div className="co-card">
            <div className="co-card-header">
                <div className="co-card-icon">
                    <i className="bi bi-geo-alt-fill" />
                </div>
                <div>
                    <h4 className="co-card-title">Informasi Pengiriman</h4>
                    <p className="co-card-desc">Masukkan detail alamat tujuan pengiriman</p>
                </div>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="co-form">
                {/* Nama & Email */}
                <div className="co-form-row">
                    <div className="co-field">
                        <label className="co-label">
                            <i className="bi bi-person-fill me-1" /> Nama Lengkap
                        </label>
                        <input
                            type="text"
                            {...register("nama_lengkap")}
                            className={`co-input ${errors.nama_lengkap ? 'is-invalid' : ''}`}
                            placeholder="Nama Lengkap"
                        />
                        {errors.nama_lengkap && <span className="co-error">{errors.nama_lengkap.message}</span>}
                    </div>
                    <div className="co-field">
                        <label className="co-label">
                            <i className="bi bi-envelope-fill me-1" /> Email
                        </label>
                        <input
                            type="email"
                            {...register("email")}
                            className={`co-input ${errors.email ? 'is-invalid' : ''}`}
                            placeholder="contoh@email.com"
                        />
                        {errors.email && <span className="co-error">{errors.email.message}</span>}
                    </div>
                </div>

                {/* No Telp */}
                <div className="co-field">
                    <label className="co-label">
                        <i className="bi bi-telephone-fill me-1" /> Nomor Telepon / WhatsApp
                    </label>
                    <div className="co-input-prefix-wrap">
                        <span className="co-input-prefix">+62</span>
                        <input
                            type="number"
                            {...register("notelp")}
                            className={`co-input co-input-has-prefix ${errors.notelp ? 'is-invalid' : ''}`}
                            placeholder="812xxxxxxxx"
                        />
                    </div>
                    {errors.notelp && <span className="co-error">{errors.notelp.message}</span>}
                </div>

                {/* Alamat */}
                <div className="co-field">
                    <label className="co-label">
                        <i className="bi bi-house-fill me-1" /> Alamat Lengkap
                    </label>
                    <textarea
                        {...register("alamat")}
                        className={`co-input co-textarea ${errors.alamat ? 'is-invalid' : ''}`}
                        placeholder="Jl. Contoh No. 10, RT/RW, Kelurahan, Kecamatan"
                        rows={3}
                    />
                    {errors.alamat && <span className="co-error">{errors.alamat.message}</span>}
                </div>

                {/* Provinsi & Kabupaten */}
                <div className="co-form-row">
                    <div className="co-field">
                        <label className="co-label">
                            <i className="bi bi-map-fill me-1" /> Provinsi
                        </label>
                        <select
                            {...register("provinsi")}
                            className={`co-select ${errors.provinsi ? 'is-invalid' : ''}`}
                            onChange={loadKabKota}
                        >
                            <option value="">Pilih Provinsi</option>
                            {provinsi?.map((prov, i) => (
                                <option key={i} value={prov.id}>{prov.province_name}</option>
                            ))}
                        </select>
                        {errors.provinsi && <span className="co-error">{errors.provinsi.message}</span>}
                    </div>
                    <div className="co-field">
                        <label className="co-label">
                            <i className="bi bi-building me-1" /> Kabupaten / Kota
                        </label>
                        <select
                            {...register("kabupaten")}
                            className={`co-select ${errors.kabupaten ? 'is-invalid' : ''}`}
                            defaultValue=""
                            onChange={setKabKota}
                        >
                            <option value="">Pilih Kabupaten/Kota</option>
                            {kabupaten?.map((kab) => (
                                <option key={kab.id} value={kab.id}>{kab.kabupaten_name}</option>
                            ))}
                        </select>
                        {errors.kabupaten && <span className="co-error">{errors.kabupaten.message}</span>}
                    </div>
                </div>

                {/* Kode Pos */}
                <div className="co-field" style={{ maxWidth: 200 }}>
                    <label className="co-label">
                        <i className="bi bi-mailbox me-1" /> Kode Pos
                    </label>
                    <input
                        type="number"
                        {...register("postal_code")}
                        className={`co-input ${errors.postal_code ? 'is-invalid' : ''}`}
                        placeholder="80xxx"
                    />
                    {errors.postal_code && <span className="co-error">{errors.postal_code.message}</span>}
                </div>

                <div className="co-form-footer">
                    <button type="submit" className="co-btn-primary" disabled={isLoading}>
                        {isLoading
                            ? <><span className="spinner-border spinner-border-sm me-2" role="status" /> Memproses...</>
                            : <><span>Lanjutkan ke Pengiriman</span> <i className="bi bi-arrow-right ms-2" /></>
                        }
                    </button>
                </div>
            </form>
        </div>
    );
};

export default FormAlamat;